module.exports = __webpack_public_path__ + "img/cases-brand-herborist-7.0d43a9e8.jpg";